import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { StoreState } from './../../store';
import { Competence } from './competence.interface';
import { CompetenceService } from './competence.service';

const service = new CompetenceService();

export interface CompetenceState {
   competences: Array<Competence>;
}

const CompetenceStore: Module<CompetenceState, StoreState> = {
   namespaced: true,
   state: {
      competences: [],
   },
   getters: {
      competences: (state) => state.competences,
   },
   mutations: {
      SET_COMPETENCES(state, competences: Array<Competence>) {
         state.competences = competences;
      },
   },
   actions: {
      async searchCompetences(context, query: LocationQuery) {
         const response = await service.searchCompetences({ ...query, per_page: '9999', page: '1' });
         return response.data;
      },
      async getCompetences(context, query: LocationQuery) {
         const response = await service.getCompetences({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_COMPETENCES', response.data);
         return response;
      },
   },
};

export default CompetenceStore;
